/* prettier-ignore-start */

/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file is auto-generated by TanStack Router

import { createFileRoute } from "@tanstack/react-router";

// Import Routes

import { Route as rootRoute } from "./routes/__root";
import { Route as LogoutImport } from "./routes/logout";
import { Route as LoginImport } from "./routes/login";
import { Route as AuthenticatedImport } from "./routes/_authenticated";
import { Route as IndexImport } from "./routes/index";
import { Route as AuthenticatedUserSettingsImport } from "./routes/_authenticated/user-settings";
import { Route as AuthenticatedRestrictedImport } from "./routes/_authenticated/_restricted";
import { Route as AuthenticatedCompaniesIndexImport } from "./routes/_authenticated/companies/index";
import { Route as AuthenticatedCompaniesFaqImport } from "./routes/_authenticated/companies/faq";
import { Route as AuthenticatedRestrictedExportsImport } from "./routes/_authenticated/_restricted/exports";
import { Route as AuthenticatedCompaniesCompanyIdIndexImport } from "./routes/_authenticated/companies/$companyId/index";
import { Route as AuthenticatedCompaniesCompanyIdDashboardImport } from "./routes/_authenticated/companies/$companyId/_dashboard";
import { Route as AuthenticatedCompaniesCompanyIdDashboardSettingsImport } from "./routes/_authenticated/companies/$companyId/_dashboard/settings";
import { Route as AuthenticatedCompaniesCompanyIdDashboardSessionsImport } from "./routes/_authenticated/companies/$companyId/_dashboard/sessions";
import { Route as AuthenticatedCompaniesCompanyIdDashboardEmployeesImport } from "./routes/_authenticated/companies/$companyId/_dashboard/employees";
import { Route as AuthenticatedCompaniesCompanyIdDashboardDetailsImport } from "./routes/_authenticated/companies/$companyId/_dashboard/details";
import { Route as AuthenticatedCompaniesCompanyIdDashboardDepartmentsImport } from "./routes/_authenticated/companies/$companyId/_dashboard/departments";
import { Route as AuthenticatedCompaniesCompanyIdDashboardDashboardImport } from "./routes/_authenticated/companies/$companyId/_dashboard/dashboard";
import { Route as AuthenticatedCompaniesCompanyIdDashboardCompanyImport } from "./routes/_authenticated/companies/$companyId/_dashboard/company";
import { Route as AuthenticatedCompaniesCompanyIdDashboardChildCompaniesImport } from "./routes/_authenticated/companies/$companyId/_dashboard/child-companies";
import { Route as AuthenticatedCompaniesCompanyIdDashboardAccountsImport } from "./routes/_authenticated/companies/$companyId/_dashboard/accounts";

// Create Virtual Routes

const AuthenticatedCompaniesCompanyIdImport = createFileRoute(
  "/_authenticated/companies/$companyId",
)();

// Create/Update Routes

const LogoutRoute = LogoutImport.update({
  path: "/logout",
  getParentRoute: () => rootRoute,
} as any);

const LoginRoute = LoginImport.update({
  path: "/login",
  getParentRoute: () => rootRoute,
} as any);

const AuthenticatedRoute = AuthenticatedImport.update({
  id: "/_authenticated",
  getParentRoute: () => rootRoute,
} as any);

const IndexRoute = IndexImport.update({
  path: "/",
  getParentRoute: () => rootRoute,
} as any);

const AuthenticatedUserSettingsRoute = AuthenticatedUserSettingsImport.update({
  path: "/user-settings",
  getParentRoute: () => AuthenticatedRoute,
} as any);

const AuthenticatedRestrictedRoute = AuthenticatedRestrictedImport.update({
  id: "/_restricted",
  getParentRoute: () => AuthenticatedRoute,
} as any);

const AuthenticatedCompaniesCompanyIdRoute = AuthenticatedCompaniesCompanyIdImport.update({
  path: "/companies/$companyId",
  getParentRoute: () => AuthenticatedRoute,
} as any);

const AuthenticatedCompaniesIndexRoute = AuthenticatedCompaniesIndexImport.update({
  path: "/companies/",
  getParentRoute: () => AuthenticatedRoute,
} as any);

const AuthenticatedCompaniesFaqRoute = AuthenticatedCompaniesFaqImport.update({
  path: "/companies/faq",
  getParentRoute: () => AuthenticatedRoute,
} as any);

const AuthenticatedRestrictedExportsRoute = AuthenticatedRestrictedExportsImport.update({
  path: "/exports",
  getParentRoute: () => AuthenticatedRestrictedRoute,
} as any);

const AuthenticatedCompaniesCompanyIdIndexRoute = AuthenticatedCompaniesCompanyIdIndexImport.update(
  {
    path: "/",
    getParentRoute: () => AuthenticatedCompaniesCompanyIdRoute,
  } as any,
);

const AuthenticatedCompaniesCompanyIdDashboardRoute =
  AuthenticatedCompaniesCompanyIdDashboardImport.update({
    id: "/_dashboard",
    getParentRoute: () => AuthenticatedCompaniesCompanyIdRoute,
  } as any);

const AuthenticatedCompaniesCompanyIdDashboardSettingsRoute =
  AuthenticatedCompaniesCompanyIdDashboardSettingsImport.update({
    path: "/settings",
    getParentRoute: () => AuthenticatedCompaniesCompanyIdDashboardRoute,
  } as any);

const AuthenticatedCompaniesCompanyIdDashboardSessionsRoute =
  AuthenticatedCompaniesCompanyIdDashboardSessionsImport.update({
    path: "/sessions",
    getParentRoute: () => AuthenticatedCompaniesCompanyIdDashboardRoute,
  } as any);

const AuthenticatedCompaniesCompanyIdDashboardEmployeesRoute =
  AuthenticatedCompaniesCompanyIdDashboardEmployeesImport.update({
    path: "/employees",
    getParentRoute: () => AuthenticatedCompaniesCompanyIdDashboardRoute,
  } as any);

const AuthenticatedCompaniesCompanyIdDashboardDetailsRoute =
  AuthenticatedCompaniesCompanyIdDashboardDetailsImport.update({
    path: "/details",
    getParentRoute: () => AuthenticatedCompaniesCompanyIdDashboardRoute,
  } as any);

const AuthenticatedCompaniesCompanyIdDashboardDepartmentsRoute =
  AuthenticatedCompaniesCompanyIdDashboardDepartmentsImport.update({
    path: "/departments",
    getParentRoute: () => AuthenticatedCompaniesCompanyIdDashboardRoute,
  } as any);

const AuthenticatedCompaniesCompanyIdDashboardDashboardRoute =
  AuthenticatedCompaniesCompanyIdDashboardDashboardImport.update({
    path: "/dashboard",
    getParentRoute: () => AuthenticatedCompaniesCompanyIdDashboardRoute,
  } as any);

const AuthenticatedCompaniesCompanyIdDashboardCompanyRoute =
  AuthenticatedCompaniesCompanyIdDashboardCompanyImport.update({
    path: "/company",
    getParentRoute: () => AuthenticatedCompaniesCompanyIdDashboardRoute,
  } as any);

const AuthenticatedCompaniesCompanyIdDashboardChildCompaniesRoute =
  AuthenticatedCompaniesCompanyIdDashboardChildCompaniesImport.update({
    path: "/child-companies",
    getParentRoute: () => AuthenticatedCompaniesCompanyIdDashboardRoute,
  } as any);

const AuthenticatedCompaniesCompanyIdDashboardAccountsRoute =
  AuthenticatedCompaniesCompanyIdDashboardAccountsImport.update({
    path: "/accounts",
    getParentRoute: () => AuthenticatedCompaniesCompanyIdDashboardRoute,
  } as any);

// Populate the FileRoutesByPath interface

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/": {
      id: "/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof IndexImport;
      parentRoute: typeof rootRoute;
    };
    "/_authenticated": {
      id: "/_authenticated";
      path: "";
      fullPath: "";
      preLoaderRoute: typeof AuthenticatedImport;
      parentRoute: typeof rootRoute;
    };
    "/login": {
      id: "/login";
      path: "/login";
      fullPath: "/login";
      preLoaderRoute: typeof LoginImport;
      parentRoute: typeof rootRoute;
    };
    "/logout": {
      id: "/logout";
      path: "/logout";
      fullPath: "/logout";
      preLoaderRoute: typeof LogoutImport;
      parentRoute: typeof rootRoute;
    };
    "/_authenticated/_restricted": {
      id: "/_authenticated/_restricted";
      path: "";
      fullPath: "";
      preLoaderRoute: typeof AuthenticatedRestrictedImport;
      parentRoute: typeof AuthenticatedImport;
    };
    "/_authenticated/user-settings": {
      id: "/_authenticated/user-settings";
      path: "/user-settings";
      fullPath: "/user-settings";
      preLoaderRoute: typeof AuthenticatedUserSettingsImport;
      parentRoute: typeof AuthenticatedImport;
    };
    "/_authenticated/_restricted/exports": {
      id: "/_authenticated/_restricted/exports";
      path: "/exports";
      fullPath: "/exports";
      preLoaderRoute: typeof AuthenticatedRestrictedExportsImport;
      parentRoute: typeof AuthenticatedRestrictedImport;
    };
    "/_authenticated/companies/faq": {
      id: "/_authenticated/companies/faq";
      path: "/companies/faq";
      fullPath: "/companies/faq";
      preLoaderRoute: typeof AuthenticatedCompaniesFaqImport;
      parentRoute: typeof AuthenticatedImport;
    };
    "/_authenticated/companies/": {
      id: "/_authenticated/companies/";
      path: "/companies";
      fullPath: "/companies";
      preLoaderRoute: typeof AuthenticatedCompaniesIndexImport;
      parentRoute: typeof AuthenticatedImport;
    };
    "/_authenticated/companies/$companyId": {
      id: "/_authenticated/companies/$companyId";
      path: "/companies/$companyId";
      fullPath: "/companies/$companyId";
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdImport;
      parentRoute: typeof AuthenticatedImport;
    };
    "/_authenticated/companies/$companyId/_dashboard": {
      id: "/_authenticated/companies/$companyId/_dashboard";
      path: "/companies/$companyId";
      fullPath: "/companies/$companyId";
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdDashboardImport;
      parentRoute: typeof AuthenticatedCompaniesCompanyIdRoute;
    };
    "/_authenticated/companies/$companyId/": {
      id: "/_authenticated/companies/$companyId/";
      path: "/";
      fullPath: "/companies/$companyId/";
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdIndexImport;
      parentRoute: typeof AuthenticatedCompaniesCompanyIdImport;
    };
    "/_authenticated/companies/$companyId/_dashboard/accounts": {
      id: "/_authenticated/companies/$companyId/_dashboard/accounts";
      path: "/accounts";
      fullPath: "/companies/$companyId/accounts";
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdDashboardAccountsImport;
      parentRoute: typeof AuthenticatedCompaniesCompanyIdDashboardImport;
    };
    "/_authenticated/companies/$companyId/_dashboard/child-companies": {
      id: "/_authenticated/companies/$companyId/_dashboard/child-companies";
      path: "/child-companies";
      fullPath: "/companies/$companyId/child-companies";
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdDashboardChildCompaniesImport;
      parentRoute: typeof AuthenticatedCompaniesCompanyIdDashboardImport;
    };
    "/_authenticated/companies/$companyId/_dashboard/company": {
      id: "/_authenticated/companies/$companyId/_dashboard/company";
      path: "/company";
      fullPath: "/companies/$companyId/company";
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdDashboardCompanyImport;
      parentRoute: typeof AuthenticatedCompaniesCompanyIdDashboardImport;
    };
    "/_authenticated/companies/$companyId/_dashboard/dashboard": {
      id: "/_authenticated/companies/$companyId/_dashboard/dashboard";
      path: "/dashboard";
      fullPath: "/companies/$companyId/dashboard";
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdDashboardDashboardImport;
      parentRoute: typeof AuthenticatedCompaniesCompanyIdDashboardImport;
    };
    "/_authenticated/companies/$companyId/_dashboard/departments": {
      id: "/_authenticated/companies/$companyId/_dashboard/departments";
      path: "/departments";
      fullPath: "/companies/$companyId/departments";
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdDashboardDepartmentsImport;
      parentRoute: typeof AuthenticatedCompaniesCompanyIdDashboardImport;
    };
    "/_authenticated/companies/$companyId/_dashboard/details": {
      id: "/_authenticated/companies/$companyId/_dashboard/details";
      path: "/details";
      fullPath: "/companies/$companyId/details";
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdDashboardDetailsImport;
      parentRoute: typeof AuthenticatedCompaniesCompanyIdDashboardImport;
    };
    "/_authenticated/companies/$companyId/_dashboard/employees": {
      id: "/_authenticated/companies/$companyId/_dashboard/employees";
      path: "/employees";
      fullPath: "/companies/$companyId/employees";
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdDashboardEmployeesImport;
      parentRoute: typeof AuthenticatedCompaniesCompanyIdDashboardImport;
    };
    "/_authenticated/companies/$companyId/_dashboard/sessions": {
      id: "/_authenticated/companies/$companyId/_dashboard/sessions";
      path: "/sessions";
      fullPath: "/companies/$companyId/sessions";
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdDashboardSessionsImport;
      parentRoute: typeof AuthenticatedCompaniesCompanyIdDashboardImport;
    };
    "/_authenticated/companies/$companyId/_dashboard/settings": {
      id: "/_authenticated/companies/$companyId/_dashboard/settings";
      path: "/settings";
      fullPath: "/companies/$companyId/settings";
      preLoaderRoute: typeof AuthenticatedCompaniesCompanyIdDashboardSettingsImport;
      parentRoute: typeof AuthenticatedCompaniesCompanyIdDashboardImport;
    };
  }
}

// Create and export the route tree

interface AuthenticatedRestrictedRouteChildren {
  AuthenticatedRestrictedExportsRoute: typeof AuthenticatedRestrictedExportsRoute;
}

const AuthenticatedRestrictedRouteChildren: AuthenticatedRestrictedRouteChildren = {
  AuthenticatedRestrictedExportsRoute: AuthenticatedRestrictedExportsRoute,
};

const AuthenticatedRestrictedRouteWithChildren = AuthenticatedRestrictedRoute._addFileChildren(
  AuthenticatedRestrictedRouteChildren,
);

interface AuthenticatedCompaniesCompanyIdDashboardRouteChildren {
  AuthenticatedCompaniesCompanyIdDashboardAccountsRoute: typeof AuthenticatedCompaniesCompanyIdDashboardAccountsRoute;
  AuthenticatedCompaniesCompanyIdDashboardChildCompaniesRoute: typeof AuthenticatedCompaniesCompanyIdDashboardChildCompaniesRoute;
  AuthenticatedCompaniesCompanyIdDashboardCompanyRoute: typeof AuthenticatedCompaniesCompanyIdDashboardCompanyRoute;
  AuthenticatedCompaniesCompanyIdDashboardDashboardRoute: typeof AuthenticatedCompaniesCompanyIdDashboardDashboardRoute;
  AuthenticatedCompaniesCompanyIdDashboardDepartmentsRoute: typeof AuthenticatedCompaniesCompanyIdDashboardDepartmentsRoute;
  AuthenticatedCompaniesCompanyIdDashboardDetailsRoute: typeof AuthenticatedCompaniesCompanyIdDashboardDetailsRoute;
  AuthenticatedCompaniesCompanyIdDashboardEmployeesRoute: typeof AuthenticatedCompaniesCompanyIdDashboardEmployeesRoute;
  AuthenticatedCompaniesCompanyIdDashboardSessionsRoute: typeof AuthenticatedCompaniesCompanyIdDashboardSessionsRoute;
  AuthenticatedCompaniesCompanyIdDashboardSettingsRoute: typeof AuthenticatedCompaniesCompanyIdDashboardSettingsRoute;
}

const AuthenticatedCompaniesCompanyIdDashboardRouteChildren: AuthenticatedCompaniesCompanyIdDashboardRouteChildren =
  {
    AuthenticatedCompaniesCompanyIdDashboardAccountsRoute:
      AuthenticatedCompaniesCompanyIdDashboardAccountsRoute,
    AuthenticatedCompaniesCompanyIdDashboardChildCompaniesRoute:
      AuthenticatedCompaniesCompanyIdDashboardChildCompaniesRoute,
    AuthenticatedCompaniesCompanyIdDashboardCompanyRoute:
      AuthenticatedCompaniesCompanyIdDashboardCompanyRoute,
    AuthenticatedCompaniesCompanyIdDashboardDashboardRoute:
      AuthenticatedCompaniesCompanyIdDashboardDashboardRoute,
    AuthenticatedCompaniesCompanyIdDashboardDepartmentsRoute:
      AuthenticatedCompaniesCompanyIdDashboardDepartmentsRoute,
    AuthenticatedCompaniesCompanyIdDashboardDetailsRoute:
      AuthenticatedCompaniesCompanyIdDashboardDetailsRoute,
    AuthenticatedCompaniesCompanyIdDashboardEmployeesRoute:
      AuthenticatedCompaniesCompanyIdDashboardEmployeesRoute,
    AuthenticatedCompaniesCompanyIdDashboardSessionsRoute:
      AuthenticatedCompaniesCompanyIdDashboardSessionsRoute,
    AuthenticatedCompaniesCompanyIdDashboardSettingsRoute:
      AuthenticatedCompaniesCompanyIdDashboardSettingsRoute,
  };

const AuthenticatedCompaniesCompanyIdDashboardRouteWithChildren =
  AuthenticatedCompaniesCompanyIdDashboardRoute._addFileChildren(
    AuthenticatedCompaniesCompanyIdDashboardRouteChildren,
  );

interface AuthenticatedCompaniesCompanyIdRouteChildren {
  AuthenticatedCompaniesCompanyIdDashboardRoute: typeof AuthenticatedCompaniesCompanyIdDashboardRouteWithChildren;
  AuthenticatedCompaniesCompanyIdIndexRoute: typeof AuthenticatedCompaniesCompanyIdIndexRoute;
}

const AuthenticatedCompaniesCompanyIdRouteChildren: AuthenticatedCompaniesCompanyIdRouteChildren = {
  AuthenticatedCompaniesCompanyIdDashboardRoute:
    AuthenticatedCompaniesCompanyIdDashboardRouteWithChildren,
  AuthenticatedCompaniesCompanyIdIndexRoute: AuthenticatedCompaniesCompanyIdIndexRoute,
};

const AuthenticatedCompaniesCompanyIdRouteWithChildren =
  AuthenticatedCompaniesCompanyIdRoute._addFileChildren(
    AuthenticatedCompaniesCompanyIdRouteChildren,
  );

interface AuthenticatedRouteChildren {
  AuthenticatedRestrictedRoute: typeof AuthenticatedRestrictedRouteWithChildren;
  AuthenticatedUserSettingsRoute: typeof AuthenticatedUserSettingsRoute;
  AuthenticatedCompaniesFaqRoute: typeof AuthenticatedCompaniesFaqRoute;
  AuthenticatedCompaniesIndexRoute: typeof AuthenticatedCompaniesIndexRoute;
  AuthenticatedCompaniesCompanyIdRoute: typeof AuthenticatedCompaniesCompanyIdRouteWithChildren;
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedRestrictedRoute: AuthenticatedRestrictedRouteWithChildren,
  AuthenticatedUserSettingsRoute: AuthenticatedUserSettingsRoute,
  AuthenticatedCompaniesFaqRoute: AuthenticatedCompaniesFaqRoute,
  AuthenticatedCompaniesIndexRoute: AuthenticatedCompaniesIndexRoute,
  AuthenticatedCompaniesCompanyIdRoute: AuthenticatedCompaniesCompanyIdRouteWithChildren,
};

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
);

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute;
  "": typeof AuthenticatedRestrictedRouteWithChildren;
  "/login": typeof LoginRoute;
  "/logout": typeof LogoutRoute;
  "/user-settings": typeof AuthenticatedUserSettingsRoute;
  "/exports": typeof AuthenticatedRestrictedExportsRoute;
  "/companies/faq": typeof AuthenticatedCompaniesFaqRoute;
  "/companies": typeof AuthenticatedCompaniesIndexRoute;
  "/companies/$companyId": typeof AuthenticatedCompaniesCompanyIdDashboardRouteWithChildren;
  "/companies/$companyId/": typeof AuthenticatedCompaniesCompanyIdIndexRoute;
  "/companies/$companyId/accounts": typeof AuthenticatedCompaniesCompanyIdDashboardAccountsRoute;
  "/companies/$companyId/child-companies": typeof AuthenticatedCompaniesCompanyIdDashboardChildCompaniesRoute;
  "/companies/$companyId/company": typeof AuthenticatedCompaniesCompanyIdDashboardCompanyRoute;
  "/companies/$companyId/dashboard": typeof AuthenticatedCompaniesCompanyIdDashboardDashboardRoute;
  "/companies/$companyId/departments": typeof AuthenticatedCompaniesCompanyIdDashboardDepartmentsRoute;
  "/companies/$companyId/details": typeof AuthenticatedCompaniesCompanyIdDashboardDetailsRoute;
  "/companies/$companyId/employees": typeof AuthenticatedCompaniesCompanyIdDashboardEmployeesRoute;
  "/companies/$companyId/sessions": typeof AuthenticatedCompaniesCompanyIdDashboardSessionsRoute;
  "/companies/$companyId/settings": typeof AuthenticatedCompaniesCompanyIdDashboardSettingsRoute;
}

export interface FileRoutesByTo {
  "/": typeof IndexRoute;
  "": typeof AuthenticatedRestrictedRouteWithChildren;
  "/login": typeof LoginRoute;
  "/logout": typeof LogoutRoute;
  "/user-settings": typeof AuthenticatedUserSettingsRoute;
  "/exports": typeof AuthenticatedRestrictedExportsRoute;
  "/companies/faq": typeof AuthenticatedCompaniesFaqRoute;
  "/companies": typeof AuthenticatedCompaniesIndexRoute;
  "/companies/$companyId": typeof AuthenticatedCompaniesCompanyIdIndexRoute;
  "/companies/$companyId/accounts": typeof AuthenticatedCompaniesCompanyIdDashboardAccountsRoute;
  "/companies/$companyId/child-companies": typeof AuthenticatedCompaniesCompanyIdDashboardChildCompaniesRoute;
  "/companies/$companyId/company": typeof AuthenticatedCompaniesCompanyIdDashboardCompanyRoute;
  "/companies/$companyId/dashboard": typeof AuthenticatedCompaniesCompanyIdDashboardDashboardRoute;
  "/companies/$companyId/departments": typeof AuthenticatedCompaniesCompanyIdDashboardDepartmentsRoute;
  "/companies/$companyId/details": typeof AuthenticatedCompaniesCompanyIdDashboardDetailsRoute;
  "/companies/$companyId/employees": typeof AuthenticatedCompaniesCompanyIdDashboardEmployeesRoute;
  "/companies/$companyId/sessions": typeof AuthenticatedCompaniesCompanyIdDashboardSessionsRoute;
  "/companies/$companyId/settings": typeof AuthenticatedCompaniesCompanyIdDashboardSettingsRoute;
}

export interface FileRoutesById {
  __root__: typeof rootRoute;
  "/": typeof IndexRoute;
  "/_authenticated": typeof AuthenticatedRouteWithChildren;
  "/login": typeof LoginRoute;
  "/logout": typeof LogoutRoute;
  "/_authenticated/_restricted": typeof AuthenticatedRestrictedRouteWithChildren;
  "/_authenticated/user-settings": typeof AuthenticatedUserSettingsRoute;
  "/_authenticated/_restricted/exports": typeof AuthenticatedRestrictedExportsRoute;
  "/_authenticated/companies/faq": typeof AuthenticatedCompaniesFaqRoute;
  "/_authenticated/companies/": typeof AuthenticatedCompaniesIndexRoute;
  "/_authenticated/companies/$companyId": typeof AuthenticatedCompaniesCompanyIdRouteWithChildren;
  "/_authenticated/companies/$companyId/_dashboard": typeof AuthenticatedCompaniesCompanyIdDashboardRouteWithChildren;
  "/_authenticated/companies/$companyId/": typeof AuthenticatedCompaniesCompanyIdIndexRoute;
  "/_authenticated/companies/$companyId/_dashboard/accounts": typeof AuthenticatedCompaniesCompanyIdDashboardAccountsRoute;
  "/_authenticated/companies/$companyId/_dashboard/child-companies": typeof AuthenticatedCompaniesCompanyIdDashboardChildCompaniesRoute;
  "/_authenticated/companies/$companyId/_dashboard/company": typeof AuthenticatedCompaniesCompanyIdDashboardCompanyRoute;
  "/_authenticated/companies/$companyId/_dashboard/dashboard": typeof AuthenticatedCompaniesCompanyIdDashboardDashboardRoute;
  "/_authenticated/companies/$companyId/_dashboard/departments": typeof AuthenticatedCompaniesCompanyIdDashboardDepartmentsRoute;
  "/_authenticated/companies/$companyId/_dashboard/details": typeof AuthenticatedCompaniesCompanyIdDashboardDetailsRoute;
  "/_authenticated/companies/$companyId/_dashboard/employees": typeof AuthenticatedCompaniesCompanyIdDashboardEmployeesRoute;
  "/_authenticated/companies/$companyId/_dashboard/sessions": typeof AuthenticatedCompaniesCompanyIdDashboardSessionsRoute;
  "/_authenticated/companies/$companyId/_dashboard/settings": typeof AuthenticatedCompaniesCompanyIdDashboardSettingsRoute;
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | ""
    | "/login"
    | "/logout"
    | "/user-settings"
    | "/exports"
    | "/companies/faq"
    | "/companies"
    | "/companies/$companyId"
    | "/companies/$companyId/"
    | "/companies/$companyId/accounts"
    | "/companies/$companyId/child-companies"
    | "/companies/$companyId/company"
    | "/companies/$companyId/dashboard"
    | "/companies/$companyId/departments"
    | "/companies/$companyId/details"
    | "/companies/$companyId/employees"
    | "/companies/$companyId/sessions"
    | "/companies/$companyId/settings";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | ""
    | "/login"
    | "/logout"
    | "/user-settings"
    | "/exports"
    | "/companies/faq"
    | "/companies"
    | "/companies/$companyId"
    | "/companies/$companyId/accounts"
    | "/companies/$companyId/child-companies"
    | "/companies/$companyId/company"
    | "/companies/$companyId/dashboard"
    | "/companies/$companyId/departments"
    | "/companies/$companyId/details"
    | "/companies/$companyId/employees"
    | "/companies/$companyId/sessions"
    | "/companies/$companyId/settings";
  id:
    | "__root__"
    | "/"
    | "/_authenticated"
    | "/login"
    | "/logout"
    | "/_authenticated/_restricted"
    | "/_authenticated/user-settings"
    | "/_authenticated/_restricted/exports"
    | "/_authenticated/companies/faq"
    | "/_authenticated/companies/"
    | "/_authenticated/companies/$companyId"
    | "/_authenticated/companies/$companyId/_dashboard"
    | "/_authenticated/companies/$companyId/"
    | "/_authenticated/companies/$companyId/_dashboard/accounts"
    | "/_authenticated/companies/$companyId/_dashboard/child-companies"
    | "/_authenticated/companies/$companyId/_dashboard/company"
    | "/_authenticated/companies/$companyId/_dashboard/dashboard"
    | "/_authenticated/companies/$companyId/_dashboard/departments"
    | "/_authenticated/companies/$companyId/_dashboard/details"
    | "/_authenticated/companies/$companyId/_dashboard/employees"
    | "/_authenticated/companies/$companyId/_dashboard/sessions"
    | "/_authenticated/companies/$companyId/_dashboard/settings";
  fileRoutesById: FileRoutesById;
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren;
  LoginRoute: typeof LoginRoute;
  LogoutRoute: typeof LogoutRoute;
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  LoginRoute: LoginRoute,
  LogoutRoute: LogoutRoute,
};

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();

/* prettier-ignore-end */

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/_authenticated",
        "/login",
        "/logout"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/_authenticated": {
      "filePath": "_authenticated.tsx",
      "children": [
        "/_authenticated/_restricted",
        "/_authenticated/user-settings",
        "/_authenticated/companies/faq",
        "/_authenticated/companies/",
        "/_authenticated/companies/$companyId"
      ]
    },
    "/login": {
      "filePath": "login.tsx"
    },
    "/logout": {
      "filePath": "logout.tsx"
    },
    "/_authenticated/_restricted": {
      "filePath": "_authenticated/_restricted.tsx",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/_restricted/exports"
      ]
    },
    "/_authenticated/user-settings": {
      "filePath": "_authenticated/user-settings.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/_restricted/exports": {
      "filePath": "_authenticated/_restricted/exports.tsx",
      "parent": "/_authenticated/_restricted"
    },
    "/_authenticated/companies/faq": {
      "filePath": "_authenticated/companies/faq.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/companies/": {
      "filePath": "_authenticated/companies/index.tsx",
      "parent": "/_authenticated"
    },
    "/_authenticated/companies/$companyId": {
      "filePath": "_authenticated/companies/$companyId",
      "parent": "/_authenticated",
      "children": [
        "/_authenticated/companies/$companyId/_dashboard",
        "/_authenticated/companies/$companyId/"
      ]
    },
    "/_authenticated/companies/$companyId/_dashboard": {
      "filePath": "_authenticated/companies/$companyId/_dashboard.tsx",
      "parent": "/_authenticated/companies/$companyId",
      "children": [
        "/_authenticated/companies/$companyId/_dashboard/accounts",
        "/_authenticated/companies/$companyId/_dashboard/child-companies",
        "/_authenticated/companies/$companyId/_dashboard/company",
        "/_authenticated/companies/$companyId/_dashboard/dashboard",
        "/_authenticated/companies/$companyId/_dashboard/departments",
        "/_authenticated/companies/$companyId/_dashboard/details",
        "/_authenticated/companies/$companyId/_dashboard/employees",
        "/_authenticated/companies/$companyId/_dashboard/sessions",
        "/_authenticated/companies/$companyId/_dashboard/settings"
      ]
    },
    "/_authenticated/companies/$companyId/": {
      "filePath": "_authenticated/companies/$companyId/index.tsx",
      "parent": "/_authenticated/companies/$companyId"
    },
    "/_authenticated/companies/$companyId/_dashboard/accounts": {
      "filePath": "_authenticated/companies/$companyId/_dashboard/accounts.tsx",
      "parent": "/_authenticated/companies/$companyId/_dashboard"
    },
    "/_authenticated/companies/$companyId/_dashboard/child-companies": {
      "filePath": "_authenticated/companies/$companyId/_dashboard/child-companies.tsx",
      "parent": "/_authenticated/companies/$companyId/_dashboard"
    },
    "/_authenticated/companies/$companyId/_dashboard/company": {
      "filePath": "_authenticated/companies/$companyId/_dashboard/company.tsx",
      "parent": "/_authenticated/companies/$companyId/_dashboard"
    },
    "/_authenticated/companies/$companyId/_dashboard/dashboard": {
      "filePath": "_authenticated/companies/$companyId/_dashboard/dashboard.tsx",
      "parent": "/_authenticated/companies/$companyId/_dashboard"
    },
    "/_authenticated/companies/$companyId/_dashboard/departments": {
      "filePath": "_authenticated/companies/$companyId/_dashboard/departments.tsx",
      "parent": "/_authenticated/companies/$companyId/_dashboard"
    },
    "/_authenticated/companies/$companyId/_dashboard/details": {
      "filePath": "_authenticated/companies/$companyId/_dashboard/details.tsx",
      "parent": "/_authenticated/companies/$companyId/_dashboard"
    },
    "/_authenticated/companies/$companyId/_dashboard/employees": {
      "filePath": "_authenticated/companies/$companyId/_dashboard/employees.tsx",
      "parent": "/_authenticated/companies/$companyId/_dashboard"
    },
    "/_authenticated/companies/$companyId/_dashboard/sessions": {
      "filePath": "_authenticated/companies/$companyId/_dashboard/sessions.tsx",
      "parent": "/_authenticated/companies/$companyId/_dashboard"
    },
    "/_authenticated/companies/$companyId/_dashboard/settings": {
      "filePath": "_authenticated/companies/$companyId/_dashboard/settings.tsx",
      "parent": "/_authenticated/companies/$companyId/_dashboard"
    }
  }
}
ROUTE_MANIFEST_END */
